export default {
    name: "Disclaimer",
    created() {
        this.$nextTick(function () {
 
        });
    },
    mounted() {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    methods: {

    }
};